// webcall-demo-data-toggle-sep25-1134 — web-call "Use demo data" helpers.
//
// The fictional fixture is owned by the BACKEND (web_call_demo.py): the browser
// only previews it (GET /web-calls/demo-fixture) and sends `demo_mode: true`.
// A demo payload deliberately carries NO webhook_context / test_webhook_url /
// field dictionary, so a stale or late webhook load (webhookData is shared with
// the phone form) can never ride into a demo session. OFF returns the exact
// pre-existing webhook payload.

export const DEMO_FIXTURE_PATH = '/web-calls/demo-fixture';

// Flatten the first valid webhook contact exactly like the existing web/phone
// forms do (nested "context" keys promoted so @{VARIABLE} resolution works).
export function webhookContextFrom(webhookData) {
  if (!(webhookData?.valid_preview?.length > 0)) return undefined;
  const { context: ctx, ...rest } = webhookData.valid_preview[0];
  return { ...rest, ...(ctx || {}) };
}

export function buildWebCallPayload({
  agentId,
  testWebhookUrl,
  genderSwitch,
  demoMode,
  webhookData,
  fieldDescriptions,
  fieldFormats,
}) {
  const payload = { agent_id: agentId };
  if (genderSwitch) payload.gender_switch = true;

  if (demoMode) {
    payload.demo_mode = true;
    return payload;
  }

  if (testWebhookUrl) payload.test_webhook_url = testWebhookUrl;
  const ctx = webhookContextFrom(webhookData);
  if (ctx) payload.webhook_context = ctx;
  if (Object.values(fieldDescriptions || {}).some((v) => v?.trim())) {
    payload.field_descriptions = fieldDescriptions;
  }
  const nonDefaultFormats = Object.fromEntries(
    Object.entries(fieldFormats || {}).filter(([, v]) => v && v !== 'none')
  );
  if (Object.keys(nonDefaultFormats).length > 0) {
    payload.field_formats = nonDefaultFormats;
  }
  return payload;
}

// A demo request is only safe to connect when the backend confirms it stored
// the fenced demo session. An older backend silently drops `demo_mode` and
// would run an UNFENCED real session (real calendar/WA tools) — refuse it.
export function demoEchoConfirmed(requestedDemo, responseData) {
  if (!requestedDemo) return true;
  return (
    responseData?.demo_mode === true &&
    !!responseData?.demo_context &&
    typeof responseData.demo_context === 'object'
  );
}

export function isUsableDemoFixture(data) {
  return !!(
    data &&
    data.fictional === true &&
    data.display &&
    typeof data.display === 'object' &&
    data.context &&
    typeof data.context === 'object'
  );
}
